import { color, font, query, space } from '@design/templateFns';
import styled from 'styled-components';

export const ReadMore = styled.div`
  ${font('body-sm')};
  color: #404040;
  line-height: 22px;
  display: block;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
  margin-top: 8px;
`;

export const AboutSectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: 700;
  font-family: var(--ev-header-font);
  margin-bottom: 40px;
`;

export const TestimonialTitle = styled.h4`
  ${font('subhead-lg')};
`;
export const TestimonialRating = styled.p``;
export const TestimonialRatingIcon = {
  color: color('warning'),
  fontSize: 18,
  '&.advisor-rating': {
    gap: 1,
  },
};

export const TestimonialAuthor = styled.p`
  ${font('body-sm-light')};
  color: ${color('gray5')};
  padding-bottom: 0;
`;

export const ListContainer = styled.div`
  position: relative;
  width: 100%;
  overflow-x: hidden;
  padding-bottom: 0;

  /* mobile single slide carousel */
  padding-right: 0;
  /* larger sizes */

  .slick-dots {
    display: flex !important;
    flex-direction: row;
    justify-content: center;
    list-style: none;
    padding-inline-start: 0;
    margin-top: 20px;
  }
  .slick-list {
    overflow: visible;
  }
  .slick-track {
    display: flex;
    flex-wrap: nowrap;
    z-index: 4;
  }
  .slick-slide {
    // position: relative !important;
    display: flex;
  }
  .slick-slide > div {
    display: flex;
    flex: 0 0 100%;
  }
`;

export const CarouselSlot = styled.span`
  position: relative !important;
`;

export const Wrapper = styled.div`
  display: block;
  margin: auto;
  max-width: 870px;
  @media screen and (${query.below('desktop')}) {
    width: auto;
  }
`;

export const CarouselContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: start;
  margin: 30px;

  @media screen and (${query.below('desktop')}) {
    width: auto;
    margin: 0 !important;
  }
`;

export const CarouselArrow = styled.div<{ $right?: boolean }>`
  margin-right: ${({ $right }) => ($right ? '32px' : '0')};
  margin-left: ${({ $right }) => ($right ? '0' : '32px')};
  height: 22px;
  width: 15px;
  border-radius: 50%;
  cursor: pointer;
  border: 1.5px solid #d4d4d4;
  margin-top: 38px;
  padding: 5px 10px;
  svg {
    position: relative;
    color: #969696;
  }

  @media screen and (${query.below('tablet')}) {
    display: none;
  }
`;

export const AdvisorBio = styled.div`
  margin: auto;
`;

export const AdvisorBioWrapper = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  margin-top: 16px;
`;

export const AdvisorBioBlock = styled.div`
  @media screen and (${query.atLeast('tablet')}) {
    margin: auto;
    max-width: 600px;
  }
`;

export const AdvisorBioBlockData = styled.div`
  width: 600px;
  line-height: 24.8px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  ${font('body-md')};
  p,
  ul,
  ol {
    ${font('body-md-light')};
    list-style-position: inside;
  }

  @media screen and (${query.below('desktop')}) {
    width: auto;
  }
`;

export const AdvisorBioBlockMediaWrapper = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;
  min-width: 300px;
  justify-content: center;
  align-items: center;

  @media screen and (${query.atLeast('tablet')}) {
    min-width: 600px;
  }
  .react-player,
  img {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    object-fit: cover;
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  @media screen and (${query.atLeast('tablet')}) {
    width: 514px;
  }
`;

export const ImageBox = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;
  img {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    object-fit: cover;
  }
`;

export const TestimonialWrapper = styled.div`
  position: relative;
  padding-bottom: ${space('xl')};
  margin-top: 64px;
  @media screen and (${query.atLeast('tablet')}) {
    &:before {
      left: -${space('x6')};
      position: absolute;
      top: 0;
      margin: 0;
      padding-bottom: 0;
      height: 100%;
    }
  }
`;
export const TestimonialBlock = styled.div`
  @media screen and (${query.atLeast('tablet')}) {
    max-width: 600px;
    margin: auto;
  }
`;
export const TestimonialBlockItem = styled.div`
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  @media screen and (${query.atLeast('tablet')}) {
    &:first-child {
      padding-top: 0;
    }
  }

  @media screen and (${query.below('desktop')}) {
    width: auto;
  }
`;
